module.exports = __webpack_public_path__ + "fonts/TTFirs-Medium.712dd0ff.woff";